import { useAppDispatch, useAppSelector } from '@/app/hooks';
import SusDeleteButton from '@/components/Sus/buttons/SusDeleteButton';
import SusEditButton from '@/components/Sus/buttons/SusEditButton';
import SusIngestionsButton from '@/components/Sus/buttons/SusIngestionsButton';
import {
  clearDrawer,
  closeDrawer,
  selectDrawerConfig,
  selectDrawerIsOpen,
} from '@/features/drawer/drawerSlice';
import AffectationFormDrawer from '@/features/drawer/drawers/AffectationFormDrawer';
import SusDetailDrawer from '@/features/drawer/drawers/SusDetailDrawer';
import SusFormDrawer from '@/features/drawer/drawers/SusFormDrawer';
import { useIsAdmin } from '@/shared/auth/useDirectusUser';
import { Drawer, Group, ScrollArea } from '@mantine/core';

const DrawerManager = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectDrawerIsOpen);
  const config = useAppSelector(selectDrawerConfig);
  const isAdmin = useIsAdmin();

  const handleClose = () => {
    dispatch(closeDrawer());
  };

  const renderContent = () => {
    if (!config) return null;
    switch (config.type) {
      case 'affectation-form':
        return <AffectationFormDrawer payload={config.payload} />;
      case 'sus-form':
        return <SusFormDrawer payload={config.payload} />;
      case 'sus-detail':
        return <SusDetailDrawer payload={config.payload} />;
      default:
        return null;
    }
  };

  // Le panneau de consultation propose un raccourci vers l'édition à côté du titre.
  const renderTitle = () =>
    config?.type === 'sus-detail' ? (
      <Group gap="xs" component="span">
        {config.title}
        {isAdmin && <SusIngestionsButton id={config.payload.susId} onClick={handleClose} />}
        <SusEditButton id={config.payload.susId} />
        {isAdmin && <SusDeleteButton id={config.payload.susId} onDeleted={handleClose} />}
      </Group>
    ) : (
      config?.title
    );

  return (
    <Drawer
      opened={isOpen}
      onClose={handleClose}
      position="right"
      title={renderTitle()}
      size="lg"
      scrollAreaComponent={ScrollArea.Autosize}
      onTransitionEnd={() => {
        if (!isOpen) {
          dispatch(clearDrawer());
        }
      }}
    >
      {renderContent()}
    </Drawer>
  );
};

export default DrawerManager;
